(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-collections-scroll]').forEach((sentinel) => {
      if (sentinel.dataset.initialized) return;
      sentinel.dataset.initialized = 'true';
      const section = sentinel.closest('section');
      const grid = section.querySelector('[data-collections-grid]');
      const link = sentinel.querySelector('[data-collections-next]');
      const status = sentinel.querySelector('[data-collections-status]');
      let loading = false;
      let observer;
      const load = async (event) => {
        event?.preventDefault();
        if (loading || !link.hasAttribute('href')) return;
        loading = true;
        observer?.unobserve(sentinel);
        status.textContent = 'Loading more collections…';
        try {
          const response = await fetch(link.href);
          if (!response.ok) throw new Error('Unable to load collections');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextSection = page.getElementById(section.id);
          const nextGrid = nextSection?.querySelector('[data-collections-grid]');
          if (!nextGrid) throw new Error('Collections grid missing');
          grid.append(...Array.from(nextGrid.children));
          const nextLink = nextSection.querySelector('[data-collections-next]');
          if (nextLink) {
            link.href = nextLink.href;
            status.textContent = 'Scroll to load more collections';
            observer?.observe(sentinel);
          } else {
            link.removeAttribute('href');
            link.hidden = true;
            status.textContent = 'All collections loaded';
            observer?.disconnect();
          }
        } catch (error) {
          status.textContent = 'Unable to load more collections. Select Load more to retry.';
          link.classList.remove('sr-only');
        } finally {
          loading = false;
        }
      };
      link.addEventListener('click', load);
      if ('IntersectionObserver' in window) {
        link.classList.add('sr-only');
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) load();
        }, { rootMargin: '300px 0px' });
        observer.observe(sentinel);
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
